export const visit = (vm, at) => {
at({ "en": { "conversations-thread-view": { "access-control": { "adminAccessRequired": "Please contact your administrator for edit access." } } } });
};